var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConciergeLoader = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C9.08262 1 6.28473 2.15892 4.22183 4.22182C2.15893 6.28472 1 9.08262 1 12C1 14.9174 2.15892 17.7153 4.22182 19.7782C6.28472 21.8411 9.08262 23 12 23",
  stroke: "url(#paint0_linear_529_6579)",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_529_6579",
  x1: 2.5,
  y1: 16,
  x2: 12,
  y2: 1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0DA5E4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0DA5E4"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgConciergeLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/concierge-loader.afe84bba500f64ca4c0047421e9abe51.svg";